import React from 'react';
import './QueryResults.css';
import TierDecisionCard from './visualizations/TierDecisionCard';
import DiseaseFamilyCard from './visualizations/DiseaseFamilyCard';
import ClinicalSummaryCard from './visualizations/ClinicalSummaryCard';
import DrugMol from './visualizations/DrugMol';
import PredictionsEvidenceCard from './visualizations/PredictionsEvidenceCard';
import TherapeuticImplicationsCard from './visualizations/TherapeuticImplicationsCard';
import TranscriptConsequencesCard from './visualizations/TranscriptConsequencesCard';
import ColocatedVariantsCard from './visualizations/ColocatedVariantsCard';
import DatabaseAnnotationsCard from './visualizations/DatabaseAnnotationsCard';
import RawAnnotationsCard from './visualizations/RawAnnotationsCard';
import ClinicalTrialsCard from './visualizations/ClinicalTrialsCard';

function QueryResults({ searchResults }) {
    if (!searchResults || !searchResults.tier_decision || !searchResults.decision_support || !searchResults.after_enrichment) {
        return (
            <div className="ONCRP-TOOLS-QP-results-container">
                <p className="ONCRP-TOOLS-QP-loading-text">Awaiting valid and complete search results...</p>
            </div>
        );
    }

    const { search_term, after_enrichment: vep, decision_support: ds, tier_decision, disease_tree } = searchResults;
    const { variant_identity: vi, therapeutic_implications: ti, associated_diseases, clinical_significance } = ds;
    
    // --- FIX: Create a simple array of disease names for legacy components ---
    const associatedDiseaseNames = Array.isArray(associated_diseases) 
        ? associated_diseases.map(d => d.name) 
        : [];

    const oncoKbData = vep.custom_annotations?.OncoKB;
    const clinVarAnnotations = vep.custom_annotations?.ClinVar;
    const civicAnnotations = vep.custom_annotations?.CIViC;
    const trialsData = ds.clinical_trials || vep.custom_annotations?.ClinicalTrials;

    return (
        <div className="ONCRP-TOOLS-QP-results-container">
            <div className="ONCRP-TOOLS-QP-grid">
                <ClinicalSummaryCard 
                    variantIdentity={vi} 
                    clinicalSignificance={clinical_significance} 
                    oncoKbData={oncoKbData} 
                    vepData={vep}
                    searchTerm={search_term}
                />
            
            
   
                <TierDecisionCard tierDecision={tier_decision} />
                <DrugMol 
                    therapeuticImplications={ti} 
                    oncoKbData={oncoKbData} 
                    variantIdentity={vi} 
                />
                {/* This component gets the NEW rich array of objects */}
                <DiseaseFamilyCard 
                    diseaseTree={disease_tree} 
                    associatedDiseases={associated_diseases} 
                />
                
                <TherapeuticImplicationsCard 
                    therapeuticImplications={ti} 
                />

                <ClinicalTrialsCard
                    trialsData={trialsData}
                />
                
                <TranscriptConsequencesCard 
                    vepData={vep} 
                />
                
                <ColocatedVariantsCard 
                    vepData={vep} 
                />
                
                {/* This component gets the OLD simple array of strings */}
                <DatabaseAnnotationsCard 
                    clinVarAnnotations={clinVarAnnotations} 
                    associatedDiseases={associatedDiseaseNames} 
                />
                             
                <PredictionsEvidenceCard 
                    vepData={vep} 
                    oncoKbData={oncoKbData} 
                />
              
            </div>
        </div>
    );
}

export default QueryResults;
